import axiosUmbraco from "../../../axios/axiosUmbraco";
import { formatDate } from "../../../helper/formatDate";
import { formatDateTimeToString } from "../../../helper/formatDateTimeToString";

const pageId = process.env.REACT_APP_NEWS_ID;
export function getNews(id = pageId) {
    const currentLanguage = localStorage.getItem('ecupLang') ?? 'en';
    return new Promise((resolve, reject) => {
        axiosUmbraco.get(`/umbraco/delivery/api/v2/content?fetch=children:${id}&skip=0&take=1000`).then(res => {
            if (res.status == 200) {
                const formattedData = res?.data?.items?.map((item) => ({
                    id: item.id,
                    date: item?.properties?.newsDate ?? '',
                    formattedDate: formatDateTimeToString(item?.properties?.newsDate, currentLanguage == 'en' ? 'en-US' : 'ar-AE') ?? '',
                    link: item?.properties?.externalLink ?? '',
                    name: item?.properties?.newsTitle ?? '',
                    description: item?.properties?.newsShortDescription ?? '',
                    image: item?.properties?.newsImage?.length > 0 ? item?.properties?.newsImage[0].url : '',
                }));
                const sortedData = formattedData.sort((b, a) => new Date(a?.date) - new Date(b?.date))
                resolve(sortedData);
            }
            resolve(false);
        }).catch(error => reject(false))
    })
}
